import {Pipe, PipeTransform} from '@angular/core';
import {FieldDataDto} from '../../../Models/Tasks/General/task.interface';
import {FieldTypesEnum} from '../../../Shared/Enum/field-types.enum';

@Pipe({
  name: 'fields',
  standalone: false
})
export class FieldsPipe implements PipeTransform {

  transform(items: FieldDataDto[], filters: { menu?: string, unique?: boolean }): FieldDataDto[] {

    if (!items || items.length === 0) {
      return [];
    }

    if (filters.menu === 'incidents') {

      items = items.filter((item) => item.observaciones);

    }

    if (filters.menu === 'pendents') {

      items = items.filter((item) => !item.value && item.tipo !== FieldTypesEnum.title);

    }

    if (filters.unique) {

      items = items.filter((item: FieldDataDto, index: number, self: FieldDataDto[]) =>
        self.findIndex((field) => field.id === item.id) === index && item.id);

    }

    return items;

  }

}
